import { render, staticRenderFns } from "./AboutThreeCard.vue?vue&type=template&id=48933370&scoped=true"
var script = {}
import style0 from "./AboutThreeCard.vue?vue&type=style&index=0&id=48933370&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48933370",
  null
  
)

export default component.exports